import { IImageFile } from './File.js';
import { IListResult, IPaginationResult } from './List.js';

/**
 * ActivityObjectType
 */
enum ActivityObjectType {
  ART = 'art',
  PRODUCT = 'product',
  USER_RENTAL = 'user-rental',
  COMMENT = 'comment',
  USER = 'user',
  STATUS_MESSAGE = 'status-message',
  ARTICLE = 'article',
  VOTE = 'vote',
  EVENT = 'event',
  EVENT_RSVP = 'event-rsvp',
  COLLECTION = 'collection',
}

/**
 * IActivity
 */
interface IActivity {
  id: number;
  type: string;
  activityDate: string;
  creatorType: string;
  creatorId: number;
  creatorSubType: string;
  creatorSubId: number;
  creatorRole: string;
  creatorSlug: string;
  creatorName: string;
  creatorImages: Array<IImageFile>;
  ownerType: string;
  ownerId: number;
  ownerRole: string;
  ownerAlias: string;
  ownerName: string;
  objectType: string;
  objectId: number;
  objectRole: string;
  objectSlug: string;
  objectName: string;
  objectDate: string;
  objectValue: string;
  objectSubType: string;
  objectSubId: number;
  objectImages: Array<IImageFile>;
  objectArtId: number;
  objectArtTitle: string;
  objectArtSlug: string;
  objectArtImages: Array<IImageFile>;
  objectArtArtistId: number;
  objectArtArtistAlias: string;
  objectArtArtistName: string;
  objectArtArtistImages: Array<IImageFile>;
}

/**
 * IActivityListResult
 */
interface IActivityListResult extends IListResult {
  items: Array<IActivity>;
}

/**
 * IActivityPaginationResult
 */
interface IActivityPaginationResult extends IPaginationResult {
  items: Array<IActivity>;
}

export { type IActivity, type IActivityListResult, type IActivityPaginationResult, ActivityObjectType };
